import { useEffect, useState } from "react";
import { MapPin, Phone, Clock, Instagram, Facebook, Music2 } from "lucide-react";
import api from "@/lib/api";

export default function Footer() {
  const [s, setS] = useState(null);

  useEffect(() => {
    api.get("/settings/public").then((r) => setS(r.data)).catch(() => {});
  }, []);

  const address = s?.address || "3530 S Orange Ave, Orlando, FL 32806";
  const phone = s?.phone || "(407) 930-0988";
  const socials = [
    { url: s?.instagram, Icon: Instagram, label: "Instagram" },
    { url: s?.facebook, Icon: Facebook, label: "Facebook" },
    { url: s?.tiktok, Icon: Music2, label: "TikTok" },
  ].filter((x) => x.url);

  return (
    <footer className="border-t border-stone-800 bg-stone-900 text-stone-300">
      <div className="mx-auto grid max-w-6xl gap-8 px-6 py-12 sm:grid-cols-3">
        <div>
          <div className="font-display text-xl font-extrabold text-amber-400">Flavors Nigerian Restaurant</div>
          <p className="mt-3 text-sm text-stone-400">
            Authentic West African cuisine in Orlando, Florida. Pickup ordering made simple.
          </p>
          {socials.length > 0 && (
            <div className="mt-4 flex items-center gap-3" data-testid="footer-socials">
              {socials.map(({ url, Icon, label }) => (
                <a
                  key={label}
                  href={url}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={label}
                  data-testid={`footer-social-${label.toLowerCase()}`}
                  className="flex h-9 w-9 items-center justify-center rounded-full bg-stone-800 text-stone-300 transition-colors duration-200 hover:bg-orange-700 hover:text-white"
                >
                  <Icon className="h-4 w-4" />
                </a>
              ))}
            </div>
          )}
        </div>
        <div className="space-y-2 text-sm">
          <div className="flex items-center gap-2"><MapPin className="h-4 w-4 shrink-0 text-orange-500" /> {address}</div>
          <div className="flex items-center gap-2"><Phone className="h-4 w-4 text-orange-500" /> {phone}</div>
          <div className="flex items-center gap-2"><Clock className="h-4 w-4 text-orange-500" /> Mon–Sat · 11am–7pm · Sun 1–6pm</div>
        </div>
        <div className="text-sm text-stone-400">
          <div className="font-semibold text-stone-200">Pickup Only</div>
          <p className="mt-2">Order online, pay securely, and pick up hot and fresh.</p>
        </div>
      </div>
      <div className="border-t border-stone-800 py-4 text-center text-xs text-stone-500">
        © {new Date().getFullYear()} Flavors Nigerian Restaurant · Orlando, FL
      </div>
    </footer>
  );
}
